<ion-card class="ion-padding ion-margin-horizontal wizard-widget">
  <ion-card-content class="ion-no-padding">
    <div *ngFor="let item of stepList; let index = index; let first = first; let last = last"
      class="step"
      [ngClass]="{
        'step--small': item.child,
        'step--active': item.active,
        'step--completed': item.completed && !item.active,
        'step--to-do': !item.completed && !item.active
      }">
      <div [attr.aria-hidden]="item.child" class="step-row">
        <div class="step-left">
          <div class="step-square">
            <span
              aria-hidden="true"
              *appIfView="'WIZARD_STEP_NUMBER'"
              class="numeration">
              {{index + 1}}
            </span>
            <ion-icon
              aria-hidden="true"
              *appIfView="'WIZARD_STEP_NUMBER';opposite:true"
              name="checkmark">
            </ion-icon>
            <div class="step-square-inner"></div>
          </div>
        </div>
        <h6
        [attr.aria-hidden]="item.child"
        [attr.aria-label]="first ? ('wizard_intro' | ariaLabel | translate:({ stepsCount: mainStepsCount, firstStep: (item.stepCode + '|title' | translate) })) : ''"
        [innerHTML]="item.stepCode + '|title' | translate"
          class="step-title">
        </h6>
      </div>
      <div class="step-left">
        <div *ngIf="!last" aria-hidden="true" class="step-line"></div>
      </div>
    </div>
  </ion-card-content>
</ion-card>
